(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitau-freedom-choice"] && !Shopify.designMode) return;
  try {
    

function fchoiceSelectionInit(root) {
root.querySelectorAll('.fchoice-selection-slider').forEach(function(slider) {
if(slider.dataset.ready) return;
slider.dataset.ready='true';
var track=slider.querySelector('.fchoice-selection-track');
var buttons=slider.querySelectorAll('[data-fchoice-direction]');
function update(){buttons.forEach(function(b){b.disabled=Number(b.dataset.fchoiceDirection)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2;});}
buttons.forEach(function(b){b.addEventListener('click',function(){var card=track.querySelector('.fchoice-selection-card');track.scrollBy({left:Number(b.dataset.fchoiceDirection)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap))});});});
track.addEventListener('scroll',update,{passive:true});
if(window.ResizeObserver) new ResizeObserver(update).observe(track);
update();
});
}
fchoiceSelectionInit(document);
document.addEventListener('shopify:section:load',function(e){fchoiceSelectionInit(e.target);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitau-layer-details"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const tabs=[...root.querySelectorAll('[role=tab]')],panels=[...root.querySelectorAll('[role=tabpanel]')];function show(i,focus){tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;panels[n].hidden=n!==i});if(focus)tabs[i].focus()}tabs.forEach((t,i)=>{t.addEventListener('click',()=>show(i,false));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();show(n,true)})});show(0,false);root.querySelectorAll('[data-copy]').forEach(b=>b.addEventListener('click',async()=>{const status=root.querySelector('[role=status]');try{await navigator.clipboard.writeText(b.dataset.copy);status.textContent=status.dataset.copySuccess}catch{status.textContent=status.dataset.copyError}}));root.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role=tabpanel]');if(panel)show(panels.indexOf(panel),false)})}document.querySelectorAll('[data-leaf-details]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-leaf-details]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitau-layer-native-alternatives"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('leaf-alternatives')) {
customElements.define('leaf-alternatives', class extends HTMLElement {
connectedCallback() {
 if (this.ready) return; this.ready = true;
 this.addEventListener('click', event => {
 const select = event.target.closest('.flp-option-select');
 if (select) {
 const group = select.closest('details'), panel = group.querySelector('.flp-quick-panel');
 if (panel.querySelector('[type="submit"]').getAttribute('aria-disabled') === 'true') return;
 group.querySelectorAll('.flp-option-select').forEach(b => b.setAttribute('aria-pressed', String(b === select)));
 panel.hidden = false;
 panel.dataset.price = select.dataset.price;
 panel.querySelector('.flp-quick-title').textContent = select.dataset.title.split('｜').slice(1,4).join('｜');
 panel.querySelector('[name="id"]').value = select.dataset.variant;
 const qty = panel.querySelector('[name="quantity"]');
 qty.min = select.dataset.min || '1'; qty.step = select.dataset.step || '1'; qty.value = qty.min;
 if (select.dataset.max) qty.max = select.dataset.max; else qty.removeAttribute('max');
 panel.querySelector('.product-form__error-message-wrapper').hidden = true;
 this.update(panel);
 panel.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 }
 const button = event.target.closest('[data-qty]');
 if (button) {
 const panel = button.closest('.flp-quick-panel'), qty = panel.querySelector('[name="quantity"]');
 if (Number(button.dataset.qty)>0) qty.stepUp(); else qty.stepDown();
 this.update(panel);
 }
 });
 this.addEventListener('input',event => { if(event.target.name==='quantity') this.update(event.target.closest('.flp-quick-panel')); });
}
update(panel) {
 const qty = panel.querySelector('[name="quantity"]');
 panel.querySelector('[data-subtotal]').textContent = qty.validity.valid ? new Intl.NumberFormat('ja-JP',{style:'currency',currency:'JPY'}).format(Number(panel.dataset.price)*Number(qty.value)/100) : '—';
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitau-leaf-alternatives"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('leaf-alternatives')) {
customElements.define('leaf-alternatives', class extends HTMLElement {
connectedCallback() {
 if (this.ready) return; this.ready = true;
 this.addEventListener('click', event => {
 const select = event.target.closest('.flp-option-select');
 if (select) {
 const group = select.closest('details'), panel = group.querySelector('.flp-quick-panel');
 if (panel.querySelector('[type="submit"]').getAttribute('aria-disabled') === 'true') return;
 group.querySelectorAll('.flp-option-select').forEach(b => b.setAttribute('aria-pressed', String(b === select)));
 panel.hidden = false;
 panel.dataset.price = select.dataset.price;
 panel.querySelector('.flp-quick-title').textContent = select.dataset.title.split('｜').slice(1,4).join('｜');
 panel.querySelector('[name="id"]').value = select.dataset.variant;
 const qty = panel.querySelector('[name="quantity"]');
 qty.min = select.dataset.min || '1'; qty.step = select.dataset.step || '1'; qty.value = qty.min;
 if (select.dataset.max) qty.max = select.dataset.max; else qty.removeAttribute('max');
 panel.querySelector('.product-form__error-message-wrapper').hidden = true;
 this.update(panel);
 panel.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 }
 const button = event.target.closest('[data-qty]');
 if (button) {
 const panel = button.closest('.flp-quick-panel'), qty = panel.querySelector('[name="quantity"]');
 if (Number(button.dataset.qty)>0) qty.stepUp(); else qty.stepDown();
 this.update(panel);
 }
 });
 this.addEventListener('input',event => { if(event.target.name==='quantity') this.update(event.target.closest('.flp-quick-panel')); });
}
update(panel) {
 const qty = panel.querySelector('[name="quantity"]');
 panel.querySelector('[data-subtotal]').textContent = qty.validity.valid ? new Intl.NumberFormat('ja-JP',{style:'currency',currency:'JPY'}).format(Number(panel.dataset.price)*Number(qty.value)/100) : '—';
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitau-leaf-details"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const tabs=[...root.querySelectorAll('[role=tab]')],panels=[...root.querySelectorAll('[role=tabpanel]')];function show(i,focus){tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;panels[n].hidden=n!==i});if(focus)tabs[i].focus()}tabs.forEach((t,i)=>{t.addEventListener('click',()=>show(i,false));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();show(n,true)})});show(0,false);root.querySelectorAll('[data-copy]').forEach(b=>b.addEventListener('click',async()=>{const status=root.querySelector('[role=status]');try{await navigator.clipboard.writeText(b.dataset.copy);status.textContent=status.dataset.copySuccess}catch{status.textContent=status.dataset.copyError}}));root.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role=tabpanel]');if(panel)show(panels.indexOf(panel),false)})}document.querySelectorAll('[data-leaf-details]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-leaf-details]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitau-shopping-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fitau-product-finder')) {
  customElements.define('fitau-product-finder', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.openHandler = (event) => {
        const trigger = event.target.closest('[data-fitau-find-open]');
        if (!trigger || this.dialog.open) return;
        event.preventDefault();
        this.trigger = trigger;
        const target = this.dialog.querySelector('[data-find-content]');
        target.replaceChildren();
        const cleanClone = (source) => {
          const node = source.cloneNode(true);
          [node, ...node.querySelectorAll('*')].forEach(el => {
            el.removeAttribute('id'); el.removeAttribute('data-shopify-editor-block');
          });
          return node;
        };
        ['count', 'method', 'price'].forEach(type => {
          target.append(cleanClone(this.querySelector('.ft-find__inner > [data-find-group="' + type + '"]')));
        });
        target.append(cleanClone(this.querySelector('.ft-find__inner > .ft-find__all')));
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
      };
      this.closeHandler = () => this.dialog.close();
      this.restoreHandler = () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'false'); requestAnimationFrame(() => { if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true}); }); }
      };
      this.backdropHandler = event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      };
      document.addEventListener('click', this.openHandler);
      this.dialog.querySelector('[data-find-close]').addEventListener('click', this.closeHandler);
      this.dialog.addEventListener('close', this.restoreHandler);
      this.dialog.addEventListener('click', this.backdropHandler);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.openHandler);
      if (!this.dialog) return;
      if (this.dialog.open) { this.dialog.close(); this.restoreHandler(); }
      this.dialog.querySelector('[data-find-close]').removeEventListener('click', this.closeHandler);
      this.dialog.removeEventListener('close', this.restoreHandler);
      this.dialog.removeEventListener('click', this.backdropHandler);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitau-strengths"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fitau-holder-slides')) {
  customElements.define('fitau-holder-slides', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.index = 0;
      this.slides = [...this.querySelectorAll('.fs-reasons__slide')];
      this.buttons = [...this.querySelectorAll('[data-slide]')];
      this.pause = this.querySelector('[data-pause]');
      this.stopped = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.updatePause();
      this.buttons.forEach((button, i) => button.addEventListener('click', () => { this.show(i); this.stopped = true; this.updatePause(); }));
      this.pause.addEventListener('click', () => { this.stopped = !this.stopped; this.updatePause(); });
      this.addEventListener('mouseenter', () => this.hovering = true);
      this.addEventListener('mouseleave', () => this.hovering = false);
      this.observer = new IntersectionObserver(entries => this.visible = entries[0].isIntersecting);
      this.observer.observe(this);
      this.timer = setInterval(() => { if (!this.stopped && !this.hovering && this.visible && !document.hidden && !this.contains(document.activeElement)) this.show((this.index + 1) % this.slides.length); }, 6000);
    }
    show(i) {
      this.index = i;
      this.slides.forEach((slide, n) => { slide.classList.toggle('is-active', n === i); slide.setAttribute('aria-hidden', String(n !== i)); });
      this.buttons.forEach((button, n) => button.setAttribute('aria-pressed', String(n === i)));
    }
    updatePause() { this.pause.textContent = this.stopped ? '▷' : 'Ⅱ'; this.pause.setAttribute('aria-label', this.stopped ? '写真の自動切り替えを再開' : '写真の自動切り替えを停止'); }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this; // sticky-header要素自体を参照
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        document.body.classList.add('sticky-header-enabled');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('sticky-header-enabled');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('sticky-header-enabled');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('sticky-header-enabled');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
